import '@djx/observable';
import 'simplebar';

import MainController from './controllers/main';
import { isDesktop, isIOS, isTouch } from './utils/useragent';
import AtelierLayout from './components/atelier-layout';

customElements.define('atelier-layout', AtelierLayout);

document.body.classList.add(isDesktop() ? 'is-desktop' : 'is-mobile');
document.cookie = `doj_touchDevice=${isTouch()}; path=/`;

if(isIOS()) {
  document.body.classList.add('is-ios');
}

const mainController = new MainController();

const setCssVars = () => {
  document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
  document.documentElement.style.setProperty('--app-100-vh', `${window.innerHeight}px`);
  document.documentElement.style.setProperty('--app-50-vh', `${window.innerHeight * 0.5}px`);
  document.documentElement.style.setProperty('--app-75-vh', `${window.innerHeight * 0.75}px`);
}

window.addEventListener('resize', () => setCssVars());

window.addEventListener('DOMContentLoaded', () => {
  mainController.initDynamicInclude();
  mainController.init();

  (document.querySelector('.o-roomle-iframe iframe') as HTMLElement | null)?.focus();
});

// Reopen the CCM19 cookie consent dialog from the footer "cookie settings" link.
// The link (`a[href="#open-consent-manager"]`) is CMS-managed and rendered on every
// locale (default/en/ch/ae). Its click handler was dropped when the old Comply consent
// manager was replaced by CCM19, leaving the link dead. CCM19 exposes CCM.openWidget()
// to reopen its settings dialog. Delegated so it also works for reloaded content. WBHB-9854.
document.addEventListener('click', (event) => {
  const trigger = (event.target as HTMLElement | null)?.closest('a[href$="#open-consent-manager"]');
  if (!trigger) return;

  event.preventDefault();
  window.CCM?.openWidget();
});

// All next lines triggers the preloader/spash screen on the home page only
const elPreloader = document.querySelector('#js-preloader')
const needPreload = elPreloader && !window.sessionStorage.getItem('preloader')
if (needPreload === true) {
  elPreloader?.classList.add('is-playable');
  window.sessionStorage.setItem('preloader', 'played');
}

setTimeout(() => {
  document.body.classList.add('is-played');
  if(document.body.classList.contains('is--homepage')) {
    document.body.classList.add('is-loaded');
    document.body.classList.remove('not-loaded');
    window.dispatchEvent(new Event('resize'));
  }
// }, needPreload ? 500 : (window.innerWidth < 768 ? 2250 : 0));
}, needPreload ? 500 : 0);

if(!document.body.classList.contains('is--homepage')) {
  setTimeout(()=>{
    document.body.classList.add('is-loaded');
    document.body.classList.remove('not-loaded');
    window.dispatchEvent(new Event('resize'));
  }, 300);
}
